import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@gearbox-protocol/deploy-tools-ui";
import { AlertTriangle } from "lucide-react";
import type { FC } from "react";
import { useAccount, useChainId } from "wagmi";

import { useUnpausedForkStatus } from "./context";
import useExecutionIdRPCMismatch from "./useExecutionIdRPCMismatch";

const WalletStateWarnings: FC = () => {
  const { isConnected } = useAccount();
  const { anvilChainId, rpcUrl, alias, executionId } = useUnpausedForkStatus();
  const chainId = useChainId();
  const rpcMismatch = useExecutionIdRPCMismatch();

  if (!isConnected) {
    return null;
  }

  const forkLabel = alias || executionId;
  const chainMismatch = chainId !== anvilChainId;

  if (!chainMismatch && !rpcMismatch) {
    return null;
  }

  return (
    <div className="flex flex-row items-center gap-x-2">
      {chainMismatch && (
        <Tooltip>
          <TooltipTrigger asChild>
            <AlertTriangle
              className="text-red-500"
              aria-label="Wallet is on a different chain"
            />
          </TooltipTrigger>
          <TooltipContent>
            <p>
              Wallet is connected to chain id {chainId}. Switch network to fork{" "}
              {forkLabel} (id {anvilChainId}).
            </p>
          </TooltipContent>
        </Tooltip>
      )}
      {rpcMismatch && (
        <Tooltip>
          <TooltipTrigger asChild>
            <AlertTriangle
              className="text-red-500"
              aria-label="Wallet RPC points to a different fork"
            />
          </TooltipTrigger>
          <TooltipContent>
            <p>
              Wallet RPC points to a different fork. Update the RPC URL for this
              network in your wallet to {rpcUrl}.
            </p>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};

export default WalletStateWarnings;
